import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import React from "react";
import * as actions from "../actions";
import statusViewStateToProps from "../selectors";
import StatusLayout from "./StatusLayout";

class StatusView extends React.Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    formDataJSON: PropTypes.object.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
    tabularized: PropTypes.isRequired,
    formDataFiltered: PropTypes.arrayOf(
      PropTypes.shape({
        warning_log: PropTypes.string,
        form_name: PropTypes.string,
        submission_device: PropTypes.string,
        error_log: PropTypes.string,
        submission_source: PropTypes.string,
        submission_id: PropTypes.string,
        process_form: PropTypes.bool,
        submitted_dt: PropTypes.string,
        count_error: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        count_warning: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      })
    ).isRequired,
    actions: PropTypes.shape({
      makeTemplateToDevice: PropTypes.func.isRequired,
      makeTemplateConfirmationClose: PropTypes.func.isRequired,
      getSourceFile: PropTypes.func.isRequired,
      formDataFetchSuccess: PropTypes.func.isRequired,
      changeJSONModalLevels: PropTypes.func.isRequired,
      setSearchText: PropTypes.func.isRequired,
      setDeviceToIssuing: PropTypes.func.isRequired,
      recallToDevice: PropTypes.func.isRequired,
      toggleProcessForm: PropTypes.func.isRequired,
      deleteModalClose: PropTypes.func.isRequired,
      deleteModalOpen: PropTypes.func.isRequired,
      recallConfirmationClose: PropTypes.func.isRequired,
      setServerSearchFilter: PropTypes.func.isRequired,
      recallModalOpen: PropTypes.func.isRequired,
      recallSetDevice: PropTypes.func.isRequired,
      recallModalClose: PropTypes.func.isRequired,

      makeTemplateModalOpen: PropTypes.func.isRequired,
      makeTemplateSetDevice: PropTypes.func.isRequired,
      makeTemplateModalClose: PropTypes.func.isRequired,

      changeOrderSetSubmissionID: PropTypes.func.isRequired,
      changeOrderModalOpen: PropTypes.func.isRequired,
      changeOrderModalClose: PropTypes.func.isRequired,
      changeOrderSave: PropTypes.func.isRequired,
      processLogDataInvalidate: PropTypes.func.isRequired,
      dmDevicesListFetch: PropTypes.func.isRequired,
      formDataModalClose: PropTypes.func.isRequired,
      formDataFetch: PropTypes.func.isRequired,
      formDataModalOpen: PropTypes.func.isRequired,
      closeJSONModal: PropTypes.func.isRequired,
      openJSONModal: PropTypes.func.isRequired,
      setBulkAction: PropTypes.func.isRequired,
      setRangeFilter: PropTypes.func.isRequired,
      setErrorClassFilter: PropTypes.func.isRequired,
      setSearchFilter: PropTypes.func.isRequired,
      submissionDataFetchIfNeeded: PropTypes.func.isRequired,
      openDetailsModal: PropTypes.func.isRequired,
      closeDetailsModal: PropTypes.func.isRequired,
      setDetailsModalData: PropTypes.func.isRequired,
      processLogDataFetch: PropTypes.func.isRequired,
      processLogToggleSelectAll: PropTypes.func.isRequired,
      updateProcessLogStatus: PropTypes.func.isRequired,
      addProcessLogIndex: PropTypes.func.isRequired,
      removeProcessLogIndex: PropTypes.func.isRequired,
      updateFiltersFromQuery: PropTypes.func.isRequired,
      getSubmissionErrorList: PropTypes.func.isRequired
    }).isRequired
  };

  componentDidMount() {
    document.title = "Submission Status";
    // eslint-disable-next-line react/prop-types
    if (
      this.props.location.search !== "?" &&
      this.props.location.search !== ""
    ) {
      // eslint-disable-next-line react/prop-types
      const urlParams = new URLSearchParams(
        this.props.location.search.replace("?", "")
      );
      this.props.actions.updateFiltersFromQuery(urlParams);
    }
    this.props.actions.submissionDataFetchIfNeeded();
    this.props.actions.getSubmissionErrorList();
  }

  handleRowClick(rowIndex) {
    if (!this.props.formDataFiltered) return false;
    const rowHasIssues =
      this.props.formDataFiltered[rowIndex].count_error ||
      this.props.formDataFiltered[rowIndex].count_warning;
    this.props.actions.setDetailsModalData({
      modalData: this.props.formDataFiltered[rowIndex]
    });
    if (rowHasIssues) {
      this.props.actions.processLogDataFetch();
    }
    this.props.actions.processLogDataInvalidate();
    // this.props.actions.openDetailsModal();
    return true;
  }

  handleProcessLogChangeCheckedAll(rowCount, isChecked) {
    // makes array [0..rowCount] or makes empty array (either all indexes or none)
    const array = isChecked ? [...Array(rowCount).keys()] : [];

    this.props.actions.processLogToggleSelectAll({
      indexArray: array,
      status: isChecked
    });
  }

  handleProcessLogCheck(index, isChecked) {
    // add it to list of checked indices
    if (isChecked) {
      this.props.actions.addProcessLogIndex(index);
    } else {
      this.props.actions.removeProcessLogIndex(index);
    }
  }

  handleFilesRefreshClick() {
    this.props.actions.submissionDataFetchIfNeeded();
  }

  handleOpenFormJSON(searchText = "") {
    this.props.actions.setSearchText(searchText);
    this.props.actions.formDataModalOpen();
    this.props.actions.formDataFetch();
  }

  handleRecallFormOpen() {
    this.props.actions.dmDevicesListFetch();
    this.props.actions.recallModalOpen();
  }

  handleMakeTemplateFormOpen() {
    this.props.actions.dmDevicesListFetch();
    this.props.actions.makeTemplateModalOpen();
  }

  render() {
    return (
      <StatusLayout
        {...this.props}
        onRefreshClick={() => this.handleFilesRefreshClick()}
        onRangeChange={instr => {
          this.props.actions.setRangeFilter(instr);
        }}
        onErrorClassChange={instr => {
          this.props.actions.setErrorClassFilter(instr);
        }}
        onChangeSearchText={v => this.props.actions.setSearchText(v)}
        onFilterChange={v => this.props.actions.setSearchFilter(v)}
        onStatusRowClick={(e, i) => this.handleRowClick(i)}
        onDetailsModalClose={() => this.props.actions.closeDetailsModal()}
        onSelectAllProcessLogCheck={(e, isChecked) =>
          this.handleSelectAllProcessLogs(isChecked)
        }
        onProcessLogRowCheck={(index, isChecked) =>
          this.handleProcessLogCheck(index, isChecked)
        }
        onProcessLogSelectAllCheck={(rowCount, isChecked) =>
          this.handleProcessLogChangeCheckedAll(rowCount, isChecked)
        }
        onBulkStatusChange={newStatus =>
          this.props.actions.setBulkAction(newStatus)
        }
        onBulkStatusClick={this.props.actions.updateProcessLogStatus}
        onJSONModalClose={() => this.props.actions.closeJSONModal()}
        onModalDetailsClick={this.props.actions.openJSONModal}
        onFormJSONClick={() => this.handleOpenFormJSON()}
        onFormJSONModalDetailsClose={this.props.actions.formDataModalClose}
        onFilterClear={() => this.props.actions.setSearchFilter("")}
        onChangeOrderOpen={() => this.props.actions.changeOrderModalOpen()}
        onChangeOrderClose={() => this.props.actions.changeOrderModalClose()}
        onJSONModalChangeDisplayLevels={v => {
          // workaround for react-json-inspector not refreshing
          this.props.actions.changeJSONModalLevels(v);
          const { formDataJSON: formData, tabularized } = this.props;
          this.props.actions.formDataFetchSuccess({});

          setTimeout(
            () =>
              this.props.actions.formDataFetchSuccess({
                formData,
                tabularized
              }),
            50
          );
        }}
        onSaveChangeFormOrder={() => {
          this.props.actions.changeOrderSave();
          this.props.actions.changeOrderModalClose();
          this.props.actions.closeDetailsModal();
        }}
        onSubmissionIDChange={this.props.actions.changeOrderSetSubmissionID}
        onRecallButtonClick={() => this.handleRecallFormOpen()}
        onRecallCloseClick={() => this.props.actions.recallModalClose()}
        onRecallDeviceChange={dev => this.props.actions.setDeviceToIssuing(dev)}
        onRecallSaveClick={() => {
          this.props.actions.recallToDevice();
          this.props.actions.recallModalClose();
        }}
        onMakeTemplateButtonClick={() => this.handleMakeTemplateFormOpen()}
        onMakeTemplateCloseClick={() =>
          this.props.actions.makeTemplateModalClose()
        }
        onMakeTemplateDeviceChange={dev =>
          this.props.actions.makeTemplateSetDevice({ device: dev })
        }
        onMakeTemplateSaveClick={() => {
          this.props.actions.makeTemplateToDevice();

          this.props.actions.makeTemplateModalClose();
        }}
        onMakeTemplateConfirmationCloseClick={() => {
          this.props.actions.makeTemplateConfirmationClose();
        }}
        onDeleteForm={() => {
          this.props.actions.toggleProcessForm();
          this.props.actions.deleteModalClose();
          this.props.actions.closeDetailsModal();
        }}
        onDeleteFormButtonClick={() => this.props.actions.deleteModalOpen()}
        onDeleteFormModalClose={() => this.props.actions.deleteModalClose()}
        onGetSourceFileClick={() => this.props.actions.getSourceFile()}
        onServerFilterChange={v => {
          this.props.actions.setServerSearchFilter(v);
        }}
        onFindSampleInFormDataClick={sampleID =>
          this.handleOpenFormJSON(sampleID)
        }
        onRecallConfirmationCloseClick={() => {
          this.props.actions.recallConfirmationClose();
        }}
      />
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(statusViewStateToProps, mapDispatchToProps)(StatusView);
